import { atom } from 'jotai';
import { SupportAccessStatus } from '../typings/support-access';

export const supportAccessStatusAtom = atom<SupportAccessStatus | null>(null);
